import { css } from 'styled-components/macro';

const pageTransitionTime = '150ms';

const animations = css`
  .translateLeft-appear,
  .translateRight-appear {
    opacity: 0;
  }

  .translateLeft-appear.translateLeft-appear-active,
  .translateRight-appear.translateRight-appear-active {
    opacity: 1;
    transition: all ${pageTransitionTime} cubic-bezier(0, 0.5, 0.5, 1);
  }

  .translateLeft-enter {
    opacity: 0;
    transform: translateX(3vw);
  }

  .translateLeft-enter.translateLeft-enter-active {
    opacity: 1;
    transition: all ${pageTransitionTime} cubic-bezier(0.5, 0, 1, 0.5);
    transition-delay: ${pageTransitionTime};
    transform: translateX(0);
  }

  .translateLeft-exit {
    position: absolute;
    width: 100%;
    top: 0;
    opacity: 1;
    transform: translateX(0);
  }

  .translateLeft-exit.translateLeft-exit-active {
    opacity: 0;
    transform: translateX(-3vw);
    transition: all ${pageTransitionTime} cubic-bezier(0, 0.5, 0.5, 1);
  }

  .translateRight-enter {
    opacity: 0;
    transform: translateX(-3vw);
  }

  .translateRight-enter.translateRight-enter-active {
    opacity: 1;
    transition: all ${pageTransitionTime} cubic-bezier(0, 0.5, 0.5, 1);
    transition-delay: ${pageTransitionTime};
    transform: translateX(0);
  }

  .translateRight-exit {
    position: absolute;
    width: 100%;
    top: 0;
    opacity: 1;
    transform: translateX(0);
  }

  .translateRight-exit.translateRight-exit-active {
    opacity: 0;
    transform: translateX(3vw);
    transition: all ${pageTransitionTime} cubic-bezier(0.5, 0, 1, 0.5);
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default animations;
